import createComponent from 'redux-form-material-ui/lib/createComponent';
import mapError from 'redux-form-material-ui/lib/mapError';
import AutoComplete from './AutoCompleteHOC';

export default createComponent(AutoComplete,
  ({ input:
      {onChange, onBlur, value},
       onNewRequest,
       onUpdateInput,
       dataSourceConfig,
       selectValue,
       dataSource,
       ...props }) => {

    const searchText = dataSourceConfig && dataSource
        ? (dataSource.find((item) => {
           return item[dataSourceConfig.text] === value
        }) || {})[dataSourceConfig.text]
        : value;

    const defaultSelectValue = () => {
          return typeof value === 'object' && dataSourceConfig
              ? value[dataSourceConfig.value]
              : value
      };

      return ({
          ...mapError(props),
          dataSourceConfig,
          dataSource,
          searchText: searchText || value,
          onNewRequest: value => {
              const selectedValue = selectValue ? selectValue(value) : defaultSelectValue;

              onChange(selectedValue, value);

              if (onNewRequest) {
                  onNewRequest(selectedValue, value)
              }

          },
          onUpdateInput: value => {
              onChange(value);

              if (onUpdateInput) {
                  onUpdateInput(value)
              }
          },
          onBlur: () => onBlur(value)
      });
  }
);


// WEBPACK FOOTER //
// ./app/components/Domains/AutoComplete.jsx